import { emptyValue } from "./Utils";


export function saveMc(taskId:number, inputId:number, input:HTMLElement){

    const inputs = $(input).find("input");
    let chosen = [];
    
    inputs.each((ind, obj) => {
        if ($(obj).is(":checked")){
            chosen.push(ind);
        }
    });

    chosen = (chosen.length != 0) ? chosen : emptyValue;

    return {answer: chosen};
}